/**
 * Joins the given classnames into a string by filtering out the falsy values
 * @param classes The classnames of the component
 * @returns String concatenation of the classnames without the falsy values
 */
export function classNames(...classes: (false | null | undefined | string)[]) {
  return classes.filter(Boolean).join(" ") || undefined;
}
